import axios from 'axios';

export const refreshToken = async () => {
  try {
    // Retrieve the refresh token from localStorage
    const refreshToken = localStorage.getItem('refresh_token');
    if (!refreshToken) {
      console.error('No refresh token found');
      return null;
    }

    // Call the Flask `api/refresh` endpoint
    const response = await axios.post('/api/refresh', {}, {
      headers: {
        Authorization: `Bearer ${refreshToken}`, // Use refresh token for authorization
      },
    });

    // Extract the new access token from the response
    const newAccessToken = response.data.access_token;

    // Store the new access token in localStorage
    localStorage.setItem('access_token', newAccessToken);

    console.log('Access token successfully refreshed'); // Log for debugging
    return newAccessToken; // Return the new access token
  } catch (error) {
    console.error('Error refreshing token:', error); // Log any errors
    return null; // Return null if the refresh fails
  }
};
